export const MATCH_ALL = "([^&]*)";
